module.exports = __webpack_public_path__ + "img/reachedmaximumnumber.247a940.png";